import {AxiosPromise} from 'axios';
import {apiCaller} from '@/api/apiCaller';
import {apihost} from '@/api/urls';
import {CountryEnum} from '@/models/Enums';
import {Segment, SegmentModel} from '@/modules/neovehicle/models';

const getSegmentByBrand = (filter: {
  idBrand: number;
  idVehicleTypes: number[];
  country: CountryEnum;
}): AxiosPromise<Segment[]> =>
  apiCaller.getParams(`/neovehicle/brands/segments`, apihost, filter);

const getSegmentsByModel = ({ modelName, country }: { modelName: string; country: CountryEnum }): AxiosPromise<SegmentModel[]> =>
  apiCaller.get(
    `/neovehicle/models/segments?modelName=${modelName}&country=${country}`
    , apihost);

export const segmentService = {
  getSegmentByBrand,
  getSegmentsByModel,
};
